import {TOption} from './TOption'

export const SECTOR_OPTIONS: TOption[] = [
  {value: '2', label: 'Domestik Retail'},
  {value: '4', label: 'Agrosolution'},
  {value: '1', label: 'Domestik Korperasi'},
  {value: '3', label: 'Export'}
]
